export default __webpack_public_path__ + "static/media/img-result-b-big.24debfa2.png";